import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DoorExitGlyph = /*#__PURE__*/createElement("g", {
  id: "log_out"
}, /*#__PURE__*/createElement("path", {
  d: "M39.4,69.1h25.6c0.7,0,1.4-0.7,1.4-1.4V16.4c0-0.7-0.7-1.4-1.4-1.4H39.4c0,0,0,0,0,0c-0.6,0-1.4,0.7-1.4,1.4v8.9 c0,0.4,0.2,0.7,0.4,1c0.6,0.6,1.4,0.6,2,0c0.3-0.3,0.4-0.6,0.4-1v-7.5h22.8v48.5H40.8v-7.5c0-0.4-0.2-0.7-0.4-1s-0.6-0.4-1-0.4 c-0.3,0-0.7,0.2-1,0.4c-0.3,0.3-0.4,0.6-0.4,1v9C38,68.4,38.7,69.1,39.4,69.1z"
}), /*#__PURE__*/createElement("path", {
  d: "M56.1,40.6H22.2l8-8.5c0.3-0.3,0.4-0.7,0.4-1.1c0-0.4-0.1-0.8-0.4-1c-0.5-0.5-1.6-0.3-2.1,0.2L17.9,41 c-0.2,0.2-0.4,0.6-0.4,1c0,0.4,0.1,0.7,0.4,1l10.3,10.9c0.5,0.5,1.6,0.6,2.1,0.1c0.2-0.2,0.4-0.6,0.4-1c0-0.4-0.1-0.9-0.4-1.1 l-8-8.5h33.9c0.8,0,1.4-0.6,1.4-1.4S56.9,40.6,56.1,40.6z"
}));
const DoorExit = createSvg({
  name: 'door-exit',
  path: DoorExitGlyph
});

export default DoorExit;
export { DoorExitGlyph };
